import React, { useState } from "react";
import BotAvatar from "../bot/BotAvatar";
import { useTheme } from "@emotion/react";
import { Stack, IconButton, Collapse, Box } from "@mui/material";
import MarkdownBlock from "components/react-lib/markdown-code/MarkdownBlock";
import { popupActions } from "store/react-lib/generic-ui/popup";
import { fonts } from "fonts";
import { useDispatch } from "react-redux";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export default function ToolResult({ toolResult }) {
  const [expanded, setExpanded] = useState(false);
  const dispatch = useDispatch();
  const theme = useTheme();

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <div
      style={{
        backgroundColor: theme.palette.conversationBackground.active,
        zIndex: 1,
        padding: '12px 16px',
        borderRadius: 8,
        position: "relative",
        width: "100%",
        boxSizing: "border-box",
        maxWidth: "748px",
      }}
    >
      <Stack spacing={1}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <BotAvatar botId={toolResult.toolId} />
          <IconButton 
            onClick={handleToggle} 
            size="small"
            aria-expanded={expanded}
            aria-label="show more"
          >
            {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </Stack>
        
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Box mt={1}>
            <MarkdownBlock
              markdownContent={toolResult.answer}
              canCopyCode={true}
              rawTextColor={theme.palette.text.main}
              rawCopyButtonColor={theme.palette.text.main}
              style={{
                color: theme.palette.text.main,
                lineHeight: 1.5,
                fontFamily: fonts.geist,
                overflowX: "auto",
              }}
              onCopy={() => dispatch(popupActions.showSuccess("Copied"))}
            />
          </Box>
        </Collapse>
      </Stack>
    </div>
  );
}